<template>
  <div class="mr-2">
    <!-- button/link -->
    <a @click="showSnapshot = true" class="has-text-success">
      <font-awesome-icon icon="comments"/>
    </a>
    <!-- eo:button/link -->

    <!-- context -->
    <portal v-if="showSnapshot" to="outer">
      <b-modal v-model="showSnapshot" :width="400" scroll="keep">
        <ConversationSnapshot :content="n.metaData.content"/>
      </b-modal>
    </portal>
    <!-- eo:context -->
  </div>
</template>

<script>
export default {
  props: {
    n: Object
  },
  data () {
    return {
      showSnapshot: false
    }
  },
}
</script>